(function ($) {
    $('body').on('click', '.mobile-menu-trigger', function() {
        $(this).addClass('active');
        $('header').addClass('fixed');
        $('body').addClass('fixed');
        $('.mobile-menu-content').addClass('active');
    });
    $('body').on('click', '.mobile-menu-trigger.active', function() {
        $(this).removeClass('active');
        $('header').removeClass('fixed');
        $('body').removeClass('fixed');
        $('.mobile-menu-content').removeClass('active');
    });

    $('body').on('click', '.menu-item-has-children', function() {
        $(this).children('.sub-menu').toggle();
        $(this).toggleClass('rotate');
    });

    $('.js-trigger-children').click(function() {
        $(this).toggleClass('is-open');

        var checkElement = $(this).next(),
            $parent      = $(this).parent('li');

        $parent.addClass('active');

        if(checkElement.is('ul') && checkElement.is(':visible')) {
            $parent.removeClass('active');
            checkElement.slideUp('normal');
        }

        if(checkElement.is('ul') && !checkElement.is(':visible')) {
            checkElement.slideDown('normal');
        }

        if (checkElement.is('ul')) {
            return false;
        } else {
            return true;
        }
    });



    // let lastScrollTop = 0;
    // let scrollUp = 0;
    //
    // $(window).on('load scroll', function () {
    //     const scroll = $(window).scrollTop();
    //
    //     if (scroll < lastScrollTop && scroll > 100) {
    //         scrollUp += 1;
    //
    //         if (scrollUp > 20) {
    //             $('.sticky-nav').addClass('active');
    //         }
    //     } else {
    //         scrollUp = 0;
    //
    //         $('.sticky-nav').removeClass('active');
    //     }
    //
    //     lastScrollTop = scroll;
    // })
    // var c, currentScrollTop = 0,
    //     navbar = $('header');
    // let navbar2 = $('.sticky-nav');
    // let lastScrollTop = 0;
    // let scrollUp = 0;


    // $(window).scroll(function () {
    //     const scroll = $(window).scrollTop();
    //     var a = $(window).scrollTop();
    //     var b = navbar.height();
    //     if (scroll < lastScrollTop) {
    //                 scrollUp += 1;
    //         if (scrollUp > 20) {
    //             console.log('vv')
    //             navbar.removeClass("nav-up");
    //             // navbar2.addClass("nav-up-active");
    //             // navbar2.removeClass("active")
    //             // if(currentScrollTop <= 90) {
    //             //     navbar2.removeClass("nav-up-active");
    //             //     navbar2.removeClass("active")
    //             // }
    //         }
    //     }else {
    //         scrollUp = 0;
    //         navbar.addClass("nav-up");
    //         // navbar2.addClass("active");
    //         // navbar2.removeClass("nav-up-active")
    //                 console.log('bb')
    //
    //     }
    //     lastScrollTop = scroll;
    //
    //
    //     // currentScrollTop = a;
    //     // if (c < currentScrollTop && a > b + b) {
    //     //     // navbar.addClass("nav-up");
    //     //     // navbar2.addClass("active");
    //     //     // navbar2.removeClass("nav-up-active")
    //     // }
    //     // else if (c > currentScrollTop && !(a <= b)) {
    //     //     // navbar.removeClass("nav-up");
    //     //     // navbar2.addClass("nav-up-active");
    //     //     // navbar2.removeClass("active")
    //     //     // if(currentScrollTop <= 90) {
    //     //     //     navbar2.removeClass("nav-up-active");
    //     //     //     navbar2.removeClass("active")
    //     //     // }
    //     // }
    //     // c = currentScrollTop;
    //
    //
    // });
    var lastScrollTop = 0;
    let navbar = $('header');
    let navbar2 = $('.sticky-nav');
    let subNavHeader = $('.hero-header');
    let linksMobile = $('.hero-with-navigation-links-mobile, .c-mobile-navigation-section');
    let homes_page_nav_mobile = $('.homes-page-nav-mobile');
    let blog_page_nav_mobile = $('.blog-page-nav-mobile');
    let scrollUp = 0;
    $(window).scroll(function(event){
        var st = $(window).scrollTop();
        if (st > lastScrollTop) {
            // downscroll code
            scrollUp = 0;
            if (st > 400) {
                navbar.addClass("nav-up");
                navbar2.addClass("active");
                navbar2.removeClass("nav-up-active");
                subNavHeader.removeClass("active");
                linksMobile.addClass('active-nav');
                homes_page_nav_mobile.addClass('active-nav');
                blog_page_nav_mobile.addClass('active-nav');
            }
        }else {
            scrollUp += 1;
            if(st == 0){
                navbar.removeClass("nav-up");
                navbar2.addClass("active");
                navbar2.removeClass("active")
            }
            if (scrollUp >= 20) {
                navbar.removeClass("nav-up");
                navbar2.addClass("nav-up-active");
                navbar2.removeClass("active")
                subNavHeader.addClass("active")
                linksMobile.removeClass('active-nav');
                homes_page_nav_mobile.removeClass('active-nav');
                blog_page_nav_mobile.removeClass('active-nav');
                if (st <= 200) {
                    navbar2.removeClass("nav-up-active");
                    navbar2.removeClass("active")
                    subNavHeader.removeClass("active")
                    linksMobile.removeClass('active-nav');
                    homes_page_nav_mobile.removeClass('active-nav');
                    blog_page_nav_mobile.removeClass('active-nav');
                }
            }
        }

        lastScrollTop = st;
    });



})(jQuery);
